import { SvgTon } from '@bazaar-marketplace/assets/ton';
import { useTranslations } from 'next-intl';
import { match } from 'ts-pattern';

interface NftFeeTextProps {
  feeType: 'MINTING' | 'TRANSFER';
  fee: string;
}

export function NftFeeText(props: NftFeeTextProps) {
  const t = useTranslations('my-collection.nft.fee');

  const feeText = match(props.feeType)
    .with('TRANSFER', () => t('transfer-fee'))
    .with('MINTING', () => t('minting-fee'))
    .exhaustive();

  return (
    <div className="text-white/60 font-bold text-center flex justify-center gap-2 items-center">
      {t('up-to')}
      <div className="flex items-center gap-1">
        <SvgTon className="size-4" />
        <div>{props.fee}</div>
      </div>
      {feeText}
    </div>
  );
}
